import React from 'react';
import { Box, CheckIcon, LockIcon, Text } from '@razorpay/blade/components';
import { ADD_FIELD_WIZARD_STEPS } from '../../constants';
import { StepRailIcon, StepRailItem } from '../../styles';

type StepStatus = 'active' | 'complete' | 'locked';

const getStepStatus = (stepIndex: number, currentStep: number): StepStatus => {
  if (stepIndex < currentStep) return 'complete';
  return stepIndex === currentStep ? 'active' : 'locked';
};

const getStepLabelColor = (stepIndex: number, currentStep: number) => {
  if (stepIndex === currentStep) return 'interactive.text.primary.normal';
  return stepIndex > currentStep ? 'surface.text.gray.muted' : 'surface.text.gray.normal';
};

export const StepRail = ({ currentStep }: { currentStep: number }) => (
  <Box
    borderRightWidth="thin"
    borderRightColor="surface.border.gray.subtle"
    padding={['spacing.8', 'spacing.7']}
    backgroundColor="surface.background.gray.intense">
    {ADD_FIELD_WIZARD_STEPS.map((label, stepIndex) => {
      const status = getStepStatus(stepIndex, currentStep);

      return (
        <StepRailItem key={label}>
          <StepRailIcon $status={status}>
            {status === 'complete' ? (
              <CheckIcon size="small" color="surface.icon.staticWhite.normal" />
            ) : null}
            {status === 'locked' ? (
              <LockIcon size="small" color="surface.icon.gray.muted" />
            ) : null}
          </StepRailIcon>
          <Text
            weight={status === 'active' ? 'semibold' : 'regular'}
            color={getStepLabelColor(stepIndex, currentStep)}>
            {label}
          </Text>
        </StepRailItem>
      );
    })}
  </Box>
);
